module.exports = __webpack_public_path__ + "static/media/배너 앱.5ffafff3.jpg";